import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    panel: { type: String, default: "visualization" }
  }

  setChartType(event) {
    const url = new URL(window.location.href)
    const chartType = event.currentTarget.value

    if (chartType === "auto") {
      url.searchParams.delete("chart_type")
    } else {
      url.searchParams.set("chart_type", chartType)
    }

    this.writePanel(url)
    window.location.assign(url.toString())
  }

  setPanel(event) {
    this.panelValue = event.currentTarget.dataset.panel || "visualization"

    const url = new URL(window.location.href)
    this.writePanel(url)
    window.history.replaceState({}, "", url)
  }

  writePanel(url) {
    if (this.panelValue === "visualization") {
      url.searchParams.delete("panel")
    } else {
      url.searchParams.set("panel", this.panelValue)
    }
  }
}
